/**
 * JS pro rtable - responzivní tabulky.
 */


export default function () {
	let rtables = document.querySelectorAll('.rtable');
	let rtablesNew = document.querySelectorAll('.rtable-new');

	if (rtables.length === 0 && rtablesNew.length === 0) {
		return false;
	}
	if (rtablesNew.length > 0) {
		rtables = rtablesNew;
	}

	function redrawTable() {
		rtables.forEach(function(table) {
			// Check if the table has already been modified
			if (table.getAttribute('data-modified') === 'true') {
				return;
			}
			let headerRow = table.getElementsByTagName("thead")[0].getElementsByTagName("tr")[0];
			// Get the content of the header cells
			let headerContent = [];
			for (let i = 0; i < headerRow.cells.length; i++) {
				headerContent.push(headerRow.cells[i].innerHTML);
			}
			// Insert the header content into each cell in the tbody
			let tbody = table.getElementsByTagName("tbody")[0];
			let rows = tbody.getElementsByTagName("tr");
			for (let i = 0; i < rows.length; i++) {
				let cells = rows[i].getElementsByTagName("td");
				for (let j = 0; j < cells.length; j++) {
					if (!cells[j].querySelector('.header-content')) {
						cells[j].innerHTML = '<div class="header-content">' + headerContent[j] + '</div>' + cells[j].innerHTML;
					}
				}
			}

			// Hide the header row
			headerRow.style.display = "none";
			// Mark the table as modified
			table.setAttribute('data-modified', 'true');
		});
	}

	function checkWindowSize() {
		if (window.matchMedia("(max-width: 768px)").matches) {
			redrawTable();
		} else {
			resetTables();
		}
	}

	// Function to reset the tables to their original state
	function resetTables() {
		rtables.forEach(function(table) {
			// Reset the table modification status
			table.setAttribute('data-modified', 'false');

			// Show the header row
			let headerRow = table.getElementsByTagName("thead")[0].getElementsByTagName("tr")[0];
			headerRow.style.display = "";
		});
	}

	// Attach the function to the resize event
	window.addEventListener("resize", checkWindowSize);

	// Initial check on page load
	checkWindowSize();
}
